

{{'DeleteSupplierPidMappingsByList' | translate}}

<br>
<br>
<span style="color:var(--np-error-color); font-weight: bold">
{{'ACHTUNG: Diese Makro löscht Daten unwiderruflich. Bitte erstellen Sie ggf. einen Wiederherstellungspunkt.' | translate}}
    </span>
<div class="chk-grid">
    <div class="chk-item">
        <div>Trennzeichen ","</div>
        <dx-check-box
            [hint]="' , '"
            [(value)]="kommaTrennzeichen"
        >
        </dx-check-box>
    </div>

    <div class="chk-item">
        <div>Trennzeichen ";"</div>
        <dx-check-box
            [hint]="' ; '"
            [(value)]="semikolonTrennzeichen"
        >
        </dx-check-box>
    </div>
</div>


<div>
    <div class="dx-text-area-coloured w-100">
        <dx-text-area
            [value]="inputString"
            (onValueChanged)="onValueChangedFormatListIgnoreSpace($event,kommaTrennzeichen,semikolonTrennzeichen)"
            [height]="400"
        ></dx-text-area>
    </div>
</div>

<div class="dx-field">
    <div >
        <dx-load-panel
            #loadPanel
            shadingColor="rgba(0,0,0,0.4)"
            [position]="{ of: '#list', at: 'center' }"
            [showIndicator]="true"
            [showPane]="true"
            [shading]="true"
            [hideOnOutsideClick]="false"
        ></dx-load-panel>
    </div>
</div>


<dx-button
    style="align-self: flex-end"
    stylingMode="contained"
    type="default"
    text="{{ 'Starte Makro' | translate }}"
    (onClick)="startDeleteByList()"
    class="buttonMargin"
/>
